<template>
<div class="chapter">
<div class="inner_page">
<div class="book" title="Small Bites"><div class="frontmatter"><div class="recto"><h1 class="title"><a id="index"></a>Small Bites</h1><h2 class="subtitle">Skewers, Sliders,
            and Other Party Eats</h2><h3 class="author">Eliza Cross</h3><h4>Jessica
            Nicosia-Nadler</h4><img alt="Gibbs Smith Logo" src="images/logo.jpg"/></div><div class="verso"><p class="versotitle">Small Bites</p><p class="versotitle">Skewers, Sliders,
            and Other Party Eats</p><p>Digital Edition 1.0</p><p class="copyright">Text © 2017 Eliza
            Cross</p><p>2017 Photo Copyright info</p><p>All rights reserved. No part of this book
            may be reproduced by any means whatsoever without written permission from the publisher,
            except brief portions quoted for purpose of review.</p><p class="nobreak">Gibbs
            Smith</p><p class="nobreak">P.O. Box 667</p><p>Layton, Utah 84041</p><p class="nobreak">Orders: 1.800.835.4993</p><p>www.gibbs-smith.com</p><p>ISBN:
          978-1-4236-4786-7</p></div></div><div class="frontmatter"><div class="dedication" title="Dedication"><p>To Corine van Bodegom,</p><p>who adds sparkle to every party.</p></div></div><div class="frontmatter">
</div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// index.vue?19bc0964